"use strict";

function initMap() {
  if (typeof L === "undefined" || window.yogaMapInitalized === true) {
    return false;
  }

  var mapTitle = "YOGA LOFT Poznań";
  var mymap = L.map("inner-map").setView([52.4078894, 16.9073319], 18);
  L.tileLayer("https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1Ijoib3B0aXhpbmUiLCJhIjoiY2p3NmtlM3NsMGtxdjRhcWthNW9xNGUwayJ9.gTLvesttMwAdbQm4ktddCw", {
    attribution: '<a href="https://www.mapbox.com/about/maps/" target="_blank">&copy; Mapbox</a> <a href="http://www.openstreetmap.org/about/" target="_blank">&copy; OpenStreetMap</a>',
    maxZoom: 17,
    id: "mapbox.streets"
  }).addTo(mymap);
  var marker = L.marker([52.4078894, 16.9075319]).addTo(mymap);
  marker.bindPopup("<strong>" + mapTitle + '</strong><br />ul. Gajowa 8/1<br />60-815 Poznań<br /><a href="tel:+48782087017">782 087 017</a>').openPopup();

  if (L !== undefined) {
    window.yogaMapInitalized = true;
  }
}

(function ($) {
  if ("IntersectionObserver" in window) {
    var map = document.getElementById("inner-map");
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio > 0) {
          initMap();
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.8,
      rootMargin: "0px 0px 100px 0px"
    });
    observer.observe(map);
  } else {
    initMap();
  }
})(jQuery);
"use strict";

$.fn.scrollTo = function (speed) {
  if (typeof speed === 'undefined') speed = 1000;
  $('html, body').animate({
    scrollTop: parseInt($(this).offset().top)
  }, speed);
};

(function ($) {
  //   //  sticky navigation
  var stickyNavBar = $("div.navbar");
  var stickyNavTop = stickyNavBar.offset().top + 100;
  var pageHeader = document.getElementById("pageHeader");

  function stickyNav() {
    if (window.pageYOffset > stickyNavTop) {
      pageHeader.classList.add("sticky");
    } else {
      pageHeader.classList.remove("sticky");
    }
  } //  replace links


  stickyNavBar.find("li a").each(function (index) {
    var href = $(this).attr('href');

    if (href.substring(0, 1) === "#") {
      $(this).attr('href', '/' + href);
    }
  });

  if ($("html.no-touchevents").length) {
    window.onscroll = function () {
      stickyNav();
      var windowScrollTop = window.pageYOffset;
      var stickyNavBarHeight = stickyNavBar.height();
      var anyActive = false;
      $("a.target").each(function () {
        var parentOffset = $(this).parent().offset().top;

        if (windowScrollTop + stickyNavBarHeight >= parentOffset) {
          var id = $(this).attr("name");
          $("nav a").removeClass("active");
          $('nav a[href="#' + id + '"]').addClass("active");
          anyActive = true;
        }
      });

      if (!anyActive) {
        $("nav a").removeClass("active");
      }
    }; //  nav scroll on click


    stickyNavBar.find("li a").on("click", function (e) {
      var href = $(this).attr("href");
      var targetString = "a[name=".concat(href.replace(/[#\/]+/, ""), "]");

      if (href.match(/^\/?#/) && $(targetString).length > 0) {
        e.preventDefault();
        $(targetString).scrollTo(300);
      }
    });
    stickyNav();
  }
})(jQuery);
"use strict";

(function ($) {
  $("section .post-content a.read-more-link[data-rel^=lightcase]").lightcase({
    maxHeight: 650,
    onStart: {
      addImages: function addImages() {}
    },
    onFinish: {
      fixHeightOnMobile: function fixHeightOnMobile() {
        if (isMobile) {
          var attr = $("#lightcase-case").attr("style");
          attr += "height: " + $("#lightcase-overlay").height() + "px !important";
          $("#lightcase-case").attr("style", attr);
        }
      }
    }
  });

  function changePost(ev, container, postId) {
    //  remove active classes
    container.find(".post.active, .post-picture.active").removeClass("active"); // add active classes to next post

    container.find("#post-".concat(postId, ", .post-image-").concat(postId)).addClass("active"); // change dots

    container.find(".dot.current").removeClass("current").parent().find(".dot-post-id-".concat(postId)).addClass("current"); //  update container current post id

    container.data("currentPost", parseInt(postId));
    new LazyLoad({
      elements_selector: ".yogaloft-lazy"
    });
  }

  function mapPostIdsToContainer(container) {
    var posts = container.find(".post-contents .post").map(function (i, post) {
      return $(post).attr("id").replace("post-", "");
    }).toArray();
    container.data("posts", posts);
    container.data("currentPost", parseInt(posts[0]));
  }

  function createDottedNav(container) {
    var posts = container.data("posts");
    var currentPost = container.data("currentPost");
    var footer = container.find(".post-footer");
    var nav = "";

    if (posts.length > 0) {
      var dots = posts.map(function (id) {
        return "<li data-post-id=\"".concat(id, "\" class=\"dot dot-post-id-").concat(id, "\"><a href=\"#\"></a></li>");
      }).join("");
      nav = "<ul class=\"dotted-section-nav\">".concat(dots, "</ul>");
    }

    footer.append(nav).find(".dot-post-id-".concat(currentPost)).addClass("current");
    footer.find(".dot a").on("click", function (ev) {
      ev.preventDefault();
      var dotPostId = parseInt($(this).parent().data("post-id"));
      $(document).trigger("sectionChangePost", [container, dotPostId]);
    });
  }

  function initPostControls(container) {
    var postControls = container.find(".post-controls .controls");
    var posts = container.data("posts");

    if (postControls.length > 0) {
      postControls.on("click", function (ev) {
        ev.preventDefault();
        var nextIndex = null;
        var currentIndex = posts.indexOf(container.data("currentPost").toString());
        nextIndex = $(this).hasClass("next") ? (currentIndex + 1) % posts.length : currentIndex > 0 ? currentIndex - 1 : posts.length - 1;
        $(document).trigger("sectionChangePost", [container, posts[nextIndex]]);
      });
    }
  }

  function initSections(container) {
    mapPostIdsToContainer(container);
    createDottedNav(container);
    initPostControls(container);
  }

  $(document).on("sectionChangePost", changePost); //  init postContainer

  var postsContainers = $(".section .post-wrapper");

  if (postsContainers.length > 0) {
    postsContainers.each(function (index, section) {
      initSections($(section));
    });
  } //  add section dots tooltip on hover


  if ($("html.no-touchevents").length > 0 && typeof tippy !== "undefined") {
    tippy(".dot", {
      content: "...",
      flipOnUpdate: true,
      onShow: function onShow(instance) {
        var postId = $(instance.reference).data("postId");
        var postText = $("#post-".concat(postId, " h3")).text();
        instance.setContent(postText);
      },
      onHidden: function onHidden(instance) {
        instance.setContent("...");
      }
    });
  }
})(jQuery);
"use strict";

;

(function (root, $, undefined) {
  'use strict';

  var isMobile = function isMobile() {
    return 'ontouchstart' in window;
  };

  $(function () {
    var slider = $('div.easingslider');
    $('.event-subscribe-btn').click(function (e) {
      var form = $('.article-form');
      form.addClass('openForm');
      form.scrollTo(300);
    }); // $(".article-form .wpcf7-form span.event-subscribe-btn:not(.clicked)").click(function(e){
    //   $(this).parents('form').trigger('submit');
    // });

    var docWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (isMobile && docWidth <= 880) {
      $('nav.nav').on('click', function () {
        $(this).find('ul').toggleClass('opened');
      });
    }

    if (docWidth >= 480) {
      $('.sliderBanner').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 250,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        fade: true,
        cssEase: 'linear',
        lazyLoad: 'ondemand'
      });
      $('.gallery-media-wrapper').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 6,
        lazyLoad: 'ondemand',
        responsive: [{
          breakpoint: 960,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }, {
          breakpoint: 720,
          settings: {
            centerMode: true,
            centerPadding: '20px',
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }, {
          breakpoint: 480,
          settings: 'unclick'
        }]
      }); //  end of slick sliders
    }
  });
})(void 0, jQuery);
//# sourceMappingURL=site-scripts.js.map
